export default "__VITE_ASSET__DjgJJlRy__"